import { Trans } from '@lingui/react/macro';
import { BrandSparkle } from './mag.js';

/**
 * Default pending component for the router. Renders when a navigation
 * exceeds `defaultPendingMs` — fast navigations don't flash this at
 * all (RouterProgress's thin yellow bar handles those). The animated
 * BrandSparkle is the brand mark in motion: twinkling rays + a gentle
 * 22.5° rotation that makes the 8-fold symmetric star visibly shift.
 *
 * Voice-wise the loader is system chrome, NOT Mag — Mag is the
 * strategist persona and isn't the one fetching a route. We keep the
 * indicator wordless beyond a tiny "loading" label so the founder
 * doesn't misread system latency as Mag working.
 */
export function PageLoader() {
  return (
    <div className="grid min-h-[60vh] place-items-center bg-[var(--cream)] px-6">
      <div className="flex flex-col items-center gap-5 text-[var(--ink)]">
        <BrandSparkle size={84} color="var(--spell)" className="mag-spark-twinkle" />
        <div className="flex items-center gap-2 font-mono text-[11px] font-medium uppercase tracking-[0.14em] opacity-55">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-[var(--pulse)] mag-pulse" />

          <Trans>loading</Trans>
        </div>
      </div>
    </div>
  );
}
